import { DynamicPaywallLoader } from "../../../_paywalls/public/DynamicPaywallLoader";
import { Touchpoint } from "../../../api/public/subscription-api";
import { Container, Service } from "../../../symphony";
import { AINavbarStore } from "../stores/ai-navbar.store";

@Service()
export class AINavbarService {
  private store = Container.take('global', AINavbarStore);
  private paywallLoader = DynamicPaywallLoader.ensureRegistered();

  public hideNavbar = () => {
    this.store.navbarVisible$.next(false);
  };

  public showNavbar = () => {
    this.store.navbarVisible$.next(true);
  };

  public openProfileMenuPaywall = () => {
    this.paywallLoader.openPaywall({
      touchpoint: Touchpoint.profileMenu,
      props: {}
    });
  };
}